"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function () {
            return m[k];
        }
    });
}) : (function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.operators = exports.getGroups = exports.reGroup = exports.chooseRandomWithWeight = exports.debugGen = void 0;
var tables_1 = require("./tables");
var s = __importStar(require("./staticAnalysis"));
exports.debugGen = process.env.NODE_ENV === "development";

function chooseRandomWithWeight(arr, totalWeight) {
    var rnum = ((Math.random() * totalWeight) + 1) | 0;
    var i = 0;
    while (rnum > 0) {
        rnum -= arr[i++].w;
    }
    return arr[i - 1].v;
}
exports.chooseRandomWithWeight = chooseRandomWithWeight;

function mapGroup(g) {
    //todo: replace escaped \{ and \}
    if (g[0] === "{") {
        for (var _i = 0, operators_1 = exports.operators; _i < operators_1.length; _i++) {
            var op = operators_1[_i];
            var m = g.match(op.regex);
            if (m) {
                return op.makeOperator(m);
            }
        }
        return function () {};
    }
    return g;
}
exports.reGroup = /{((\\{|\\}|[^{}])*)}|((\\{|\\}|[^{}])+)/g;

function getGroups(val) {
    if (typeof val !== "string" || val.length === 0) {
        throw new Error("Empty value to get group");
    }
    val = val.replace("{\\n}", "\n");
    var r = (val.match(exports.reGroup) || [])
        .map(function (g) {
            var r = mapGroup(g);
            if (exports.debugGen && typeof r !== "string") {
                r.original = g;
            }
            return r;
        });
    return r;
}
exports.getGroups = getGroups;

function isNumber(n) {
    return typeof n === "number";
}
/*
All supported operations
{%v1=%v2} : v1 = v2
{%v1=15} : v1 = 15
{%v1+%v2} : v1 = v1 + v2
{%v1+15} : v1 = v1 + 15
{%v1-%v2} : v1 = v1 - v2
{%v1-15} : v1 = v1 - 15
{%v1} : output v1
{$s1=$s2} : s1 = s2
{$s1=du text lala.} : s1 = txt
{$s1+$s2} : s1 = s1 + s2
{$s1+du text lala.} : s1 = s1 + txt
{$s1} : output s1
{\n} : output an endline
{table} : replace by table element
*/
exports.operators = [
    // {%v1=%v2}
    {
        regex: /^{%(.+)=%(.*)}/,
        makeOperator: function (m) {
            var v1 = m[1],
                v2 = m[2];
            return function operator(context) {
                context.vars[v1] = +context.vars[v2];
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.NumberDef(m[1])],
                use: [new s.NumberUse(m[2])]
            });
        }
    },
    // {%v1=15}
    {
        regex: /^{%(.+)=(.*)}/,
        makeOperator: function (m) {
            var v1 = m[1],
                value = +m[2];
            return function operator(context) {
                context.vars[v1] = value;
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.NumberDef(m[1])]
            });
        }
    },
    // {%v1+%v2}
    {
        regex: /^{%(.+)\+%(.*)}/,
        makeOperator: function (m) {
            var v1 = m[1],
                v2 = m[2];
            return function operator(context) {
                context.vars[v1] = (+context.vars[v1]) + (+context.vars[v2]);
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.NumberDef(m[1])],
                use: [new s.NumberUse(m[1]), new s.NumberUse(m[2])]
            });
        }
    },
    // {%v1+15}
    {
        regex: /^{%(.+)\+(.*)}/,
        makeOperator: function (m) {
            var v1 = m[1],
                value = +m[2];
            return function operator(context) {
                context.vars[v1] = (+context.vars[v1]) + value;
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.NumberDef(m[1])],
                use: [new s.NumberUse(m[1])]
            });
        }
    },
    // {%v1-%v2}
    {
        regex: /^{%(.+)-%(.*)}/,
        makeOperator: function (m) {
            var v1 = m[1],
                v2 = m[2];
            return function operator(context) {
                context.vars[v1] = (+context.vars[v1]) - (+context.vars[v2]);
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.NumberDef(m[1])],
                use: [new s.NumberUse(m[1]), new s.NumberUse(m[2])]
            });
        }
    },
    // {%v1-15}
    {
        regex: /^{%(.+)-(.*)}/,
        makeOperator: function (m) {
            var v1 = m[1],
                value = +m[2];
            return function operator(context) {
                context.vars[v1] = (+context.vars[v1]) - value;
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.NumberDef(m[1])],
                use: [new s.NumberUse(m[1])]
            });
        }
    },
    // {%v1}
    {
        regex: /^{%(.+)}/,
        makeOperator: function (m) {
            var v1 = m[1];
            return function operator(context) {
                return (+context.vars[v1]) | 0;
            };
        },
        analysis: function (m) {
            return ({
                use: [new s.NumberUse(m[1])]
            });
        }
    },
    // {$s1=$s2}
    {
        regex: /^{\$(.+)=\$(.*)}/,
        makeOperator: function (m) {
            var s1 = m[1],
                s2 = m[2];
            return function operator(context) {
                context.vars[s1] = String(context.vars[s2]);
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.StringDef(m[1])],
                use: [new s.StringUse(m[2])]
            });
        }
    },
    // {$s1=du text lala.}
    {
        regex: /^{\$(.+)=(.*)}/,
        makeOperator: function (m) {
            var s1 = m[1],
                text = m[2];
            return function operator(context) {
                context.vars[s1] = text;
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.StringDef(m[1])],
            });
        }
    },
    // {$s1+$s2}
    {
        regex: /^{\$(.+)\+\$(.*)}/,
        makeOperator: function (m) {
            var s1 = m[1],
                s2 = m[2];
            return function operator(context) {
                context.vars[s1] += String(context.vars[s2]);
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.StringDef(m[1])],
                use: [new s.StringUse(m[1]), new s.StringUse(m[2])]
            });
        }
    },
    // {$s1+du text lala.}
    {
        regex: /^{\$(.+)\+(.*)}/,
        makeOperator: function (m) {
            var s1 = m[1],
                text = m[2];
            return function operator(context) {
                context.vars[s1] += text;
            };
        },
        analysis: function (m) {
            return ({
                def: [new s.StringDef(m[1])],
                use: [new s.StringUse(m[1])]
            });
        }
    },
    // {$s1}
    {
        regex: /^{\$(.+)}/,
        makeOperator: function (m) {
            var s1 = m[1];
            return function operator(context) {
                return context.vars[s1];
            };
        },
        analysis: function (m) {
            return ({
                use: [new s.StringUse(m[1])]
            });
        }
    },
    {
        regex: /^{\\n}$/,
        makeOperator: function () {
            return function operator() {
                return "\n";
            };
        },
        analysis: function () {
            return ({});
        }
    },
    // {table}
    {
        regex: /^{(.*)}/,
        makeOperator: function (m) {
            var tablename = m[1];
            var t = tables_1.getTable(tablename);
            return function operator(context, options) {
                function chooseOption(index) {
                    if ((index >>> 0) >= t.options.length) {
                        console.warn("Index [%d] for table [%s]", index, tablename);
                        return chooseRandomWithWeight(t.options, t.w);
                    }
                    /*if(__DEV__) {
                      console.log(
                        "Table [%s] option forced to [%s]",
                        tablename,
                        t.options[index].original
                      );
                    }*/
                    return t.options[index].v;
                }
                if (tablename === "race" && isNumber(options.race)) {
                    return chooseOption(options.race);
                } else if (tablename === "forcealign" && isNumber(options.alignment)) {
                    return chooseOption(options.alignment);
                } else if (tablename === "hooks" && isNumber(options.plothook)) {
                    return chooseOption(options.plothook);
                } else if (tablename.match(/gender$/) && isNumber(options.gender)) {
                    return chooseOption(options.gender);
                }
                if (isNumber(options.subrace) &&
                    (tablename === "raceelf" ||
                        tablename === "racedwarf" ||
                        tablename === "racegnome" ||
                        tablename === "racehalfling" ||
                        tablename === "racegenasi")) {
                    return chooseOption(options.subrace);
                }
                if (isNumber(options.classorprof)) {
                    if (tablename === "occupation") {
                        return chooseOption(options.classorprof);
                    } else if (isNumber(options.occupation1) &&
                        options.classorprof === 0 &&
                        tablename === "class") {
                        return chooseOption(options.occupation1);
                    } else if (isNumber(options.occupation1) &&
                        options.classorprof === 1 &&
                        tablename === "profession") {
                        return chooseOption(options.occupation1);
                    } else if (isNumber(options.occupation1) &&
                        isNumber(options.occupation2) &&
                        options.classorprof === 1 &&
                        (tablename === "learned" ||
                            tablename === "lesserNobility" ||
                            tablename === "professional" ||
                            tablename === "workClass" ||
                            tablename === "martial" ||
                            tablename === "underclass" ||
                            tablename === "entertainer")) {
                        return chooseOption(options.occupation2);
                    }
                }
                return chooseRandomWithWeight(t.options, t.w);
            };
        },
        analysis: function (m) {
            return ({
                table: m[1]
            });
        }
    }
];